import { put, select } from 'redux-saga/effects'
import { createCrudSagas } from './CrudSagas'
import { CategoriesActions } from '../reducers/CategoriesRedux'
import { UnitsSelectors } from '../reducers/UnitsRedux'

const crudSagas = createCrudSagas('categories', CategoriesActions)

export const findCategories = crudSagas.findCategories
export const getCategory = crudSagas.getCategory
export const createCategory = crudSagas.createCategory
export const updateCategory = crudSagas.updateCategory
export const deleteCategory = crudSagas.deleteCategory
export const watchCategories = crudSagas.watchCategories

export const createdUnit = function* ({ payload }) {
  if (payload && payload.category && payload.reference) {
    yield put(CategoriesActions.increaseCategoryStats(payload))
  }
}

export const updatingUnit = function* ({ payload }) {
  if (payload && payload._id && payload.category) {
    const unit = yield select(UnitsSelectors.getUnit(payload._id))
    yield put(CategoriesActions.decreaseCategoryStats(unit))
    yield put(CategoriesActions.increaseCategoryStats({ ...unit, category: payload.category }))
  }
}
